document.addEventListener('DOMContentLoaded', function () {
    const updateReviewTitle = () => {
        document.querySelectorAll('.jm-review-widget-minimal-header__title').forEach(el => {
            if (el.textContent.trim() === 'Customer Reviews') {
                el.textContent = 'Reviews';
            }
        });
    };

    updateReviewTitle();

    const observer = new MutationObserver(updateReviewTitle);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});


document.addEventListener('DOMContentLoaded', function () {

    function hideNoItemsFound() {
        document.querySelectorAll('.jdgm-empty-state').forEach(el => {
            el.style.display = 'none';
        });
    }

    hideNoItemsFound();

    const observer = new MutationObserver(hideNoItemsFound);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});